import css from 'styles/components/account/submitReturn.scss';

const SubmitReturn = ({ onCancelReturn, onSubmitReturn, submitDisabled }) => (
  <div className={css.container}>
    <button type="button" onClick={onCancelReturn}>Cancel</button>
    <button type="button" onClick={onSubmitReturn} disabled={submitDisabled}>Submit Return</button>
  </div>
);

export default SubmitReturn;
